import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fill-bar',
  templateUrl: './fill-bar.component.html',
  styleUrls: ['./fill-bar.component.scss']
})
export class FillBarComponent {

  @Input()
  progress: number;

  @Input()
  negative: boolean = false;

}
